import { ReactElement } from 'react';

import ROUTES from '@app/src/common/constants/routeUrls';
import AuthStore from '@app/src/common/store/AuthStore';
import routerStore from '@app/src/common/store/RouterStore';

import CheckinIcon from '../assets/CheckIn.svg';
import DevicesIcon from '../assets/Devices.svg';
import CompanyIcon from '../assets/Company.svg';
import ProjectsIcon from '../assets/Projects.svg';
import ScheduleIcon from '../assets/Schedule.svg';
import StorageIcon from '../assets/Storage.svg';
import OrderIcon from '../assets/Order.svg';
import WayFindingIcon from '../assets/WayFinding.svg';
import RoomBookingIcon from '../assets/RoomBooking.svg';
import OtherIcon from '../assets/Other.svg';
import ParkingIcon from '../assets/Parking.svg';
import InventoryIcon from '../assets/Inventory.svg';
import FormIcon from '../assets/Form.svg';
import TruckIcon from '../assets/Truck.svg';

export interface ISidebarRoute {
  labelId: string;
  Icon: () => ReactElement;
  order: number;
}

// A module that lives in its own frontend app instead of a react-router route. It shares the sidebar
// ordering with SIDEBAR_ROUTES but navigates the browser away rather than pushing onto the history.
export interface IExternalModule extends ISidebarRoute {
  key: string;
  isVisible: () => boolean;
  navigate: () => void;
}

export const SIDEBAR_ROUTES: Record<string, ISidebarRoute> = {
  [ROUTES.deviceManagement.path]: {
    labelId: 'app.navigation.devices',
    Icon: DevicesIcon,
    order: 1
  },
  [ROUTES.contentManagement.path]: {
    labelId: 'app.navigation.content',
    Icon: ProjectsIcon,
    order: 2
  },
  [ROUTES.schedule.path]: {
    labelId: 'app.navigation.schedule',
    Icon: ScheduleIcon,
    order: 3
  },
  [ROUTES.fileStorage.path]: {
    labelId: 'app.navigation.storage',
    Icon: StorageIcon,
    order: 4
  },
  [ROUTES.userManagement.path]: {
    labelId: 'app.navigation.company',
    Icon: CompanyIcon,
    order: 5
  },
  [ROUTES.eventManagement.path]: {
    labelId: 'app.navigation.check.in',
    Icon: CheckinIcon,
    order: 6
  },
  [ROUTES.formManagement.path]: {
    labelId: 'app.navigation.form',
    Icon: FormIcon,
    order: 8
  },
  [ROUTES.parkingManagement.path]: {
    labelId: 'app.navigation.parking',
    Icon: ParkingIcon,
    order: 9
  },
  [ROUTES.wayFinding.path]: {
    labelId: 'app.navigation.way.finding',
    Icon: WayFindingIcon,
    order: 10
  },
  [ROUTES.orderManagement.path]: {
    labelId: 'app.navigation.order',
    Icon: OrderIcon,
    order: 11
  },
  [ROUTES.bookingManagement.path]: {
    labelId: 'app.navigation.room.signage',
    Icon: RoomBookingIcon,
    order: 12
  },
  [ROUTES.inventoryManagement.path]: {
    labelId: 'app.navigation.inventory',
    Icon: InventoryIcon,
    order: 13
  },
  [ROUTES.customSolutions.path]: {
    labelId: 'app.navigation.custom.solutions',
    Icon: OtherIcon,
    order: 14
  }
};

export const EXTERNAL_MODULES: IExternalModule[] = [
  {
    key: 'truck-management',
    labelId: 'app.navigation.truck',
    Icon: TruckIcon,
    order: 7,
    isVisible: () => AuthStore.isTruckManagementUser,
    navigate: () => routerStore.navigateToTruckManagement()
  }
];
